import React from "react";
import "./pageHeading.css";

export interface IPageHeadingProps {
  /** Small uppercase category label shown above the title (accent colored). */
  eyebrow: string;
  /** The page title, rendered in the display serif. */
  title: React.ReactNode;
  /** Optional supporting line under the title (muted). Use for a page's intro
   *  sentence so it doesn't compete with the title as a second heading. */
  sub?: React.ReactNode;
}

/** Shared page header block: an accent eyebrow above a serif title, with an
 *  optional muted subtitle. Sits just below the AppBar's control row and acts
 *  as the real heading for a page. Mirrors the "Puzzle review / date" pattern
 *  from the review screen so every page reads consistently. */
export function PageHeading({ eyebrow, title, sub }: IPageHeadingProps) {
  return (
    <div className="pagehead">
      <span className="eyebrow eyebrow--accent">{eyebrow}</span>
      <div className="pagehead__title">{title}</div>
      {sub && <div className="pagehead__sub">{sub}</div>}
    </div>
  );
}
